<template>
  <div>
    <div class="row pt-3 l-m-b-20">
      <div class="col-12">
        <h1>Edit Transactions</h1>
      </div>
    </div>
    <div class="l-bg-white">
      <form @submit.prevent="save" @keydown="clearError($event)" autocomplete="no">
        <div class="row mb-2">
          <div class="col-3 pr-1">
            <div class="select-wrap">
              <label>Created at</label>
              <p :class="{disabled: !$_can('job-charges.update')}">{{ transaction.date }}</p>
            </div>
            <error-field :errors="errors" field="created_at" />
          </div>
          <div class="col-3 px-1">
            <div class="select-wrap">
              <label>Ref id</label>
              <p :class="{disabled: !$_can('job-charges.update')}">#{{ transaction.ref_id }}</p>
            </div>
            <error-field :errors="errors" field="ref_id" />
          </div>
          <div class="col-3 pl-1">
            <div class="select-wrap">
              <label>Customer</label>
              <p :class="{disabled: !$_can('job-charges.update')}"><template v-if="transaction.customer">{{ transaction.customer.first_name }} {{ transaction.customer.last_name }}</template><span class="text-danger" v-else>Deleted customer</span> </p>
            </div>
            <error-field :errors="errors" field="customer" />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-3 pr-1">
            <div class="select-wrap">
              <label>Amount in $</label>
              <input v-model="transaction.amount" type="text" class="form-control" :disabled="!$_can('job-charges.update')" />
            </div>
            <error-field :errors="errors" field="amount" />
          </div>
          <div class="col-3 px-1">
            <div class="select-wrap">
              <label>Payment Method</label>
              <simple-select v-model="transaction.payment_method_id"
                             id="payment"
                             :options="listPaymentMethods"
                             placeholder="Select Payment Methods"
                             @input="listPaymentMethods"
                             :disabled="!$_can('job-charges.update') || transaction.payment_method_id === 4"
              />
            </div>
            <error-field :errors="errors" field="type" />
          </div>
          <div class="col-3 pl-1">
            <div class="select-wrap">
              <label>Payment type</label>
              <simple-select v-model="transaction.payment_type_id"
                             id="payment-type"
                             :options="paymentTypes"
                             placeholder="Select Payment Types"
                             @input="paymentTypes"
                             :disabled="!$_can('job-charges.update')"
              />
            </div>
            <error-field :errors="errors" field="payment_type" />
          </div>
        </div>
        <div class="row">
          <div class="col-6 pr-1">
            <div class="select-wrap">
              <label>Note</label>
              <textarea v-model="transaction.note"
                        cols="30"
                        rows="5"
                        class="form-control select-wrap-textarea"
                        :disabled="!$_can('job-charges.update')"
              />
            </div>
            <error-field :errors="errors" field="note" />
          </div>
        </div>
        <div class="row mt-5"
             v-if="$_can('job-charges.update') || $_can('job-charges.destroy')"
        >
          <div class="col" v-if="transaction.payment_method_id !== 4 && $_can('job-charges.destroy')">
            <button type="button"
                    class="btn btn-danger"
                    @click="remove(transaction.id)"
            >
              Delete
            </button>
            <error-field :errors="errors" field="charge" />
          </div>
          <div class="col" v-if="$_can('job-charges.update')">
            <button class="btn btn-primary float-right ld-ext-right"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
            >
              Save
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import toastr from 'toastr';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';

export default {
  components: {
    ErrorField,
  },
  data: () => ({
    transaction: {
      created_at: '',
      customer: {
        first_name: '',
        last_name: '',
      },
      amount: null,
      payment_type_id: null,
      payment_method_id: null,
      charge_id: '',
      note: '',
    },
    loadingButton: false,
    buttonDisabled: false,
    errors: new Errors(),
    listPaymentMethods: [],
  }),
  computed: {
    ...mapState({
      paymentMethods: state => state.values.paymentMethods,
      paymentTypes: state => state.values.paymentTypes,
    }),
  },
  mounted() {
    const chargeId = this.$route.params.id;
    axios
      .get(`charges/${chargeId}`)
      .then(res => {
        this.transaction = res.data.data;
        if (this.transaction.payment_method.id !== 4) {
          this.listPaymentMethods = this.paymentMethods.map(paymentMethod => {
            if (paymentMethod.id !== 4) {
              return paymentMethod;
            }
            paymentMethod.$isDisabled = true;
            return paymentMethod;
          });
        } else {
          this.listPaymentMethods = this.paymentMethods;
        }
        this.listPaymentMethods = this.paymentMethods.map(paymentMethod => {
          if (paymentMethod.id !== 4) {
            return paymentMethod;
          }
          paymentMethod.$isDisabled = true;
          return paymentMethod;
        });
      })
      .catch(err => this.errors.record(err.response.data.error));
    this.getPaymentMethods();
    this.getPaymentTypes();
  },
  methods: {
    ...mapActions(['getPaymentMethods', 'getPaymentTypes']),
    save() {
      const chargeId = this.transaction.id;
      this.loadingButton = true;
      this.buttonDisabled = true;
      const { transaction } = this;
      transaction.amount = transaction.amount.replace(/,/g, '');
      axios
        .put(`charges/${chargeId}`, transaction)
        .then(() => {
          toastr.success('Successfully updated transaction');
          this.$router.push('/transactions');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    remove(chargeId) {
      axios
        .delete(`charges/${chargeId}`)
        .then(() => {
          toastr.success('Successfully deleted transaction');
          this.$router.push('/transactions');
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/transactions/TransactionsEdit.vue